import React from "react";

interface ButtonProps {
  text: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  className?: string;
}

const Button: React.FC<ButtonProps> = ({
  text,
  icon,
  onClick,
  type = "button",
  disabled = false,
  className,
}) => {
  const defaultClasses =
    "w-full bg-secondary hover:bg-secondary-dark text-white font-bold py-3 px-4 text-base rounded-lg transition duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 shadow-lg hover:shadow-xl disabled:opacity-50";

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={className || defaultClasses}
    >
      <span className="flex items-center justify-center">
        {icon && <span className="mr-2 h-4 w-4 flex-shrink-0">{icon}</span>}
        {text}
      </span>
    </button>
  );
};

export default Button;
